export const FETCH_STATES_REQUEST = "FETCH_STATES_REQUEST";
export const FETCH_STATES_SUCCESS = "FETCH_STATES_SUCCESS";
export const FETCH_STATES_FAILURE = "FETCH_STATES_FAILURE";

export const ADD_TO_CART = "ADD_TO_CART";
export const REMOVE_FROM_CART = "REMOVE_FROM_CART";
export const CLEAR_CART = "CLEAR_CART";
export const UPDATE_CART_ITEM = "UPDATE_CART_ITEM";

export const SET_USER = "SET_USER";
export const SET_STORE_INFO = "SET_STORE_INFO";

export const SET_SELECTED_ADDRESS = "SET_SELECTED_ADDRESS";
export const SET_SELECTED_CARD = "SET_SELECTED_CARD";

export const SET_ROLES = "SET_ROLES";

export const SET_GRAVATAR_REQUEST = "SET_GRAVATAR_REQUEST";
export const SET_GRAVATAR_SUCCESS = "SET_GRAVATAR_SUCCESS";
export const SET_GRAVATAR_FAILURE = "SET_GRAVATAR_FAILURE";

export const SET_USER_REQUEST = "SET_USER_REQUEST";
export const SET_USER_SUCCESS = "SET_USER_SUCCESS";
export const SET_USER_FAILURE = "SET_USER_FAILURE";

export const SET_FETCH_STATE = "SET_FETCH_STATE";

export const LOGIN_REQUEST = "LOGIN_REQUEST";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAILURE = "LOGIN_FAILURE";

export const LOGOUT_REQUEST = "LOGOUT_REQUEST";
export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";
export const LOGOUT_FAILURE = "LOGOUT_FAILURE";

export const SET_GRAVATAR = "SET_GRAVATAR";

export const FETCH_CATEGORIES_REQUEST = "FETCH_CATEGORIES_REQUEST";
export const FETCH_CATEGORIES_SUCCESS = "FETCH_CATEGORIES_SUCCESS";
export const FETCH_CATEGORIES_FAILURE = "FETCH_CATEGORIES_FAILURE";

export const SET_TOP_CATEGORIES = "SET_TOP_CATEGORIES";
